import React, { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import { useDispatch, useSelector } from "react-redux";
import { api_request } from "../../store/actions/commonAction";
import { API_METHOD_GET } from "../../config/constants";
import { FormControl, InputLabel } from "@mui/material";
import { backendUrl } from "../../config/api";
import {
  getApiBody,
  getApiHeader,
  queryBuilder,
} from "../../helper/apiActionHelper";

export default function CoreAsyncSelect({
  id = "async-select",
  label = "parentId",
  display = (item) => {
    return { value: item.id, label: item.name };
  },
  onChange,
  styles,
  valueColumn,
  value,
  reducerVar,
  apiPath,
  query = {},
  loadType = null,
  successType = null,
  errorType = null,
  loading,
  asyncLoading = false,
  method = API_METHOD_GET,
}) {
  const dispatch = useDispatch();
  const [defOptions, setDefOptions] = useState([]);
  const [firstLoad, setFirstLoad] = useState(false);
  const searchResults = useSelector((state) => state?.manageData[reducerVar]);

  useEffect(() => {
    if (asyncLoading) {
      if (value) {
        baseDataCall();
      }
    } else {
      dispatch(
        api_request(
          API_METHOD_GET,
          apiPath,
          null,
          query,
          loadType,
          successType,
          errorType,
          true,
          false,
          loading,
        ),
      );
    }
  }, []);

  useEffect(() => {
    if (value && asyncLoading && defOptions?.length < 1) {
      baseDataCall();
      setFirstLoad(true);
    }
  }, [value]);

  const baseDataCall = async () => {
    let temData = await searchWithApi(value);
    setDefOptions(temData);
  };

  const searchWithApi = async (que) => {
    console.log("searchWithApi", que, query);
    const headers = getApiHeader(method, true, false);
    const apiBody = getApiBody(method, {}, false);
    try {
      let finalQuery = { ...(query || {}), search: que };
      console.log(
        "API BODY",
        apiBody,
        headers,
        finalQuery,
        apiPath,
        queryBuilder(apiPath, finalQuery),
      );
      let res = await fetch(backendUrl + queryBuilder(apiPath, finalQuery), {
        method: method,
        headers: headers,
        body: apiBody,
      });
      let data = await res.json();
      console.log("API DATA", data.data);
      if (data?.data?.rows) {
        return data?.data?.rows?.map((item) => {
          return display(item);
        });
      } else {
        return data?.data?.map((item) => {
          return display(item);
        });
      }
    } catch (error) {
      console.error("Error in searchWithApi:", error);
      return [];
    }
  };

  const filterData = (name) => {
    return searchResults
      .filter((f) => f?.name?.toLowerCase()?.includes(name?.toLowerCase()))
      ?.map((item) => {
        return display(item);
      });
  };

  const loadOptions = async (inputValue, callback) => {
    if (asyncLoading) {
      let d = await searchWithApi(inputValue);
      setDefOptions(d);
      console.log("searchWithApi data ", d);
      callback(d);
    } else {
      callback(filterData(inputValue));
    }
  };

  console.log("CoreAsyncSelect", searchResults, defOptions, value);

  return (
    <FormControl fullWidth>
      <InputLabel
        shrink
        htmlFor={id}
        sx={{ marginTop: "-12px", marginLeft: "-12px" }}
      >
        {label}
      </InputLabel>
      {!asyncLoading || (asyncLoading && firstLoad) ? (
        <AsyncSelect
          id={id}
          cacheOptions
          defaultOptions={
            asyncLoading
              ? defOptions
              : searchResults?.map((item) => {
                  return display(item);
                })
          }
          value={
            asyncLoading
              ? defOptions && defOptions.find((f) => f?.value === value)
              : searchResults &&
                searchResults.find((f) => f[valueColumn] === value) &&
                display(searchResults.find((f) => f[valueColumn] === value))
          }
          loadOptions={loadOptions}
          onChange={onChange}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          styles={{
            menuPortal: (base) => ({
              ...base,
              zIndex: 2000, // must be higher than the modal's z-index
            }),
            menu: (base) => ({
              ...base,
              zIndex: 2000,
            }),
            control: (baseStyles, state) => ({
              ...baseStyles,
              height: "50px",
              ...styles,
            }),
          }}
        />
      ) : null}
    </FormControl>
  );
}
